import { ReactNode, useRef } from "react";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "components/ui/dialog";
import Button from "common/pages/morning/-components/common/Button";

type ConfirmDialogProps = {
    handleConfirm: () => void;
    // openConfirm: (callback: () => void) => void;
    trigger: (open: () => void) => ReactNode;
    title: string;
    content: string;
    confirmButtonText: string;
};
export default function ConfirmDialog({ handleConfirm, title, trigger, content, confirmButtonText }: ConfirmDialogProps) {
    const triggerRef = useRef<HTMLButtonElement | null>(null);

    const openDialog = () => {
        triggerRef.current?.click();
    };

    return (
        <Dialog>
            <div>
                {trigger(openDialog)}
                <DialogTrigger ref={triggerRef} className="absolute" />
            </div>

            <DialogContent className="bg-white p-0 gap-0 w-[560px] rounded-lg shadow-lg overflow-hidden">
                <DialogHeader className="px-10 pt-10">
                    <DialogTitle className="text-2xl ">{title}</DialogTitle>
                    <DialogDescription hidden />
                </DialogHeader>
                <div className="px-10 pt-8 pb-10 flex-1 w-full flex flex-col gap-y-8">
                    <p className="text-[18px]">{content}</p>

                    <div className="w-full grid grid-cols-2 gap-2 items-center justify-center">
                        <DialogClose asChild className="flex-1 border rounded-lg px-7 py-3 bg-[#dddddd]">
                            <Button className="!w-full" size="L">
                                {confirmButtonText}
                            </Button>
                        </DialogClose>

                        <Button
                            onClick={() => {
                                handleConfirm();
                                openDialog(); // 닫기
                            }}
                            className="!w-full flex-1 border-none bg-new text-white"
                            size="L"
                        >
                            확인
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
